import Vue from 'vue'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'

import * as accouttypes from '@account/store/types'
import * as urlHelper from '@appbase/util/url-helper'
import { buildStyle } from "@appbase/util/popup-helper"

import axios from 'axios';

export interface BannerResponse {
    data: {
        data: BannerData[]
    }
}

export interface BannerData {
    image: string;
    url: string;
}

const tempData: BannerData[] = [
    {
        image: '/cm/gres/faux/images/portal/img-thumbnail01.jpg',
        url: 'https://dw-portal.kyobobook.io'
    },
    {
        image: '/cm/gres/faux/images/portal/img-thumbnail02.jpg',
        url: 'https://dw-portal.kyobobook.io'
    }
]

@Component({
    name: 'kbb-data-webpart',
    components: { 
        LoadingBar,
        NoData,
        WebpartTemplate
    },
    computed: mapGetters({
        current: accouttypes.CURRENT,
    }),
})
export default class DataBannerWebpart extends Mixins(WebpartBase) {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) webpart!: webpartv3.Webpart

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    current!: account.TCurrent;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    options: any = null;

    dataList: any[] = [];
    curData: any = null;
    imagePath: string = '';
    page: number = 1;
    totalPage: number = 0;

    intervalId: number = 0;
    intervalStartTime: number = new Date().getTime();
    timer:number = 5000

    isDataManager: boolean = false;

    hasError: boolean = false;
    errMessage: string = '';

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
	// 웹파트 옵션 저장값 set
	setProps() {
		this.options =
		    typeof this.webpart.props == typeof '' ? JSON.parse(this.webpart.props as string) : this.webpart.props;
    }

    load() {
        this.loading = true;

        if(this.current.permissions.roles.length>0){
            this.isDataManager = this.current.permissions.isCompanyManager || this.current.permissions.isSuperAdmin
        }

        // api 호출
        axios.get('https://api.dev-gw-service.kyobobook.io/di/main/banner').then((res: BannerResponse) => {
            if(res && res.data) {
                this.dataList = res.data.data;
                this.curData = res.data.data[0];
                this.totalPage = res.data.data.length;

                if(this.totalPage > 1){
                    this.repeatOften();
                };

                this.loading = false;
            }
        }).catch((err) => {
            if (axios.isAxiosError(err) && err.response) {
                if (err.response.status == 403) {
                    this.errMessage = this.$t('조회_권한_없음').toString();
                } else {
                    this.errMessage = this.$t('관리자_문의_필요').toString();
                }
              }
              this.hasError = true;
              this.loading = false;
        });
    }

    repeatOften(){
        // 5초마다 배너 넘김
        const callback =() =>{
            const currentTime = new Date().getTime();
            if((currentTime - this.timer) > this.intervalStartTime){
                this.changePage(1);
                this.intervalStartTime = new Date().getTime();
                this.intervalId = requestAnimationFrame(callback);
            } else {
                this.intervalId = requestAnimationFrame(callback);
            }
        }
        this.intervalId = requestAnimationFrame(callback);
    }

    changePage(val: number) {
        if (val < 0) {
            if(this.page == 1) {
              this.page = this.totalPage
            } else {
              this.page += val
            }
        }  else {
            if(val > 0 && this.page == this.totalPage) this.page = 1
            else this.page += val
        }
    }

    async handleClick() {
        // if (this.preview) return;
        if (this.curData.url) {
            var url = this.curData.url;
            var features = ''
            var target = '_blank'
    
            if (url.includes('api/processToken')) {
                var _url = new URL(url)
    
                var searchParams = _url.searchParams
    
                var redirect = searchParams.get("redirectUrl") ?? "_blank"
                _url.searchParams.delete("redirectUrl")
    
                var search: string[] = []
                search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`)
                if (_url.search !== '') {
                    var _search = _url.search.slice(1).split('&')
                    search = search.concat(_search)
                }
                var params = this.getParams(search)
    
                url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key)
                    : `${window.location.origin}${process.env.NODE_ENV === 'production' ? '/po' : ''}${redirect}`;
                target = redirect
                features = buildStyle({ width: 900, height: 800 })
            }
            else if (url.includes(window.location.host)) {
                window.location.href = url
                return
            }
    
            window.open(url, target, features);
        } else {
            (window as any).alertAsync('저장된_링크가_없습니다')
            return;
        }
    }

    getParams(search: string[]) {
        var res = ''

        for (var i = 0; i < search.length; i++) {
            res += `&${search[i]}`
        }

        if (res.startsWith('&'))
            res = res.slice(1)

        return res
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    @Watch('webpart.props')
    changeWebpartValue() {
        this.setProps();
    }

    @Watch('page')
    reloadData(val: number) {
        if(this.preview) {
            this.curData = (tempData as any)[val-1];
        } else {
            this.curData = this.dataList[val-1];
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
		if (this.webpart && this.webpart.props) {
			this.setProps();
		}

		if (this.preview) {
            this.dataList = tempData;
            this.curData = tempData[0];
            this.totalPage = tempData.length;
		} else {
			this.load();
		}
    }

    beforeDestroy(){
        cancelAnimationFrame(this.intervalId);
    }
}